<template>
  <div class="flex act-container">
    <div>
      <act-preview phoneHeaderFixed navigationBg="transparent">
        <div
          class="slot"
          :class="wheelType || 'wheel'"
          :style="{ backgroundImage: 'url(' + listHeaderImgUrl + ')' }"
        >
          <div class="change-bg">
            <div class="upload-img pointer" @click="toggleShow">更换背景</div>
          </div>
          <template v-if="wheelType === 'wheel' || !wheelType">
            <div class="music">
              <div class="hmicon icon-music"></div>
            </div>
            <div class="turnTable">
              <div
                class="circle"
                :style="{
                  backgroundImage: 'url(' + gameBgp2 + ')',
                  backgroundSize: '100% 100%'
                }"
              >
                <div class="upload-img" @click="toggleShowgameBgp2">
                  <span class="hmicon icon-shangchuantupian1"></span>
                </div>
                <div class="add-prize" @click="addChild">
                  <span class="hmicon icon-hao"></span>
                </div>
                <section class="gb-wheel-container" id="gbWheel">
                  <div
                    class="gb-wheel-content"
                    :style="{ transform: `rotate(${rotateDeg}deg)` }"
                  >
                    >
                    <ul class="gb-wheel-line">
                      <li
                        v-for="(v, i) in rule.turntablePrizeRuleList"
                        class="gb-wheel-litem"
                        :key="i"
                        :style="{
                          transform: `rotate(${i * turnNum + turnNum / 2}turn)`
                        }"
                      ></li>
                    </ul>
                    <div class="gb-wheel-list">
                      <div
                        class="gb-wheel-item"
                        v-for="(v, i) in rule.turntablePrizeRuleList"
                        :key="i"
                      >
                        <div
                          class="gb-wheel-icontent"
                          :style="{ transform: `rotate(${i * turnNum}turn)` }"
                        >
                          <div class="gb-wheel-itext">
                            <span
                              @click="addGoodsImg(v, 'prizeImg')"
                              class="hmicon add icon-shangchuantupian1"
                            ></span>
                            <span
                              @click="deleteChild(i)"
                              v-if="i > 0"
                              class="hmicon  delete hmicon icon-shanchu1 pointer"
                            ></span>
                          </div>
                          <!-- <p class="gb-wheel-money">{{ v.rankingSeqNum }}</p> -->
                          <p class="gb-wheel-itext" v-if="v.money !== '0'">
                            {{ v.prizeName }}
                          </p>
                          <div class="gb-wheel-img">
                            <img :src="v.prizeImg" alt="" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="gb-wheel-btn pointer prev-upload"
                    id="gbLottery"
                    :style="{
                      backgroundImage: 'url(' + gameBgp3 + ')',
                      backgroundSize: '100%'
                    }"
                  >
                    GO
                    <div class="upload-img" @click="toggleShowgameBgp3">
                      <span class="hmicon icon-shangchuantupian1"></span>
                    </div>
                  </div>
                </section>
              </div>
            </div>
            <div class="flex times-wrapper">
              <div class="changce flex item-center">
                <div class="changce-wrapper">
                  <span class="red-envelope"></span>
                  <span>你还有<span class="times">0次</span>抽奖机会</span>
                </div>
              </div>
            </div>
          </template>
          <template v-if="wheelType === 'grid'">
            <div
              class="grid-wheel-container prev-upload"
              :style="{ backgroundImage: 'url(' + gameBgp2 + ')' }"
            >
              <div
                class="upload-img"
                style="top:100px"
                @click="toggleShowgameBgp2"
              >
                <span class="hmicon icon-shangchuantupian1"></span>
              </div>
              <div class="flex times-wrapper flex-center">
                <div class="changce flex item-center flex-center">
                  <div class="changce-wrapper">
                    <span class="red-envelope"></span>
                    <span>你还有<span class="times">0</span>次抽奖机会</span>
                  </div>
                </div>
              </div>
              <div class="container">
                <!-- 停止位置:<input :value='luckPosition' style="width:100%;text-align:center" @input='input' type='number'></input> -->
                <div class="frame_view prev-upload">
                  <div class="upload-img" style="top: -36px" @click="addChild">
                    <span class="hmicon icon-hao"></span>
                  </div>
                  <div
                    class="frame_item"
                    v-for="(v, i) in rule.turntablePrizeRuleList"
                    :class="[
                      { active: v.active, 'no-prize': v.noPrize },
                      'prize' + i
                    ]"
                    :key="i"
                  >
                    <div class="upload-img" @click="addGoodsImg(v, 'prizeImg')">
                      <span class="hmicon icon-shangchuantupian1"></span>
                    </div>
                    <div class="img-wrapper">
                      <img class="img" :src="v.prizeImg" />
                    </div>
                    <div
                      class="delete-item"
                      @click="deleteChild(i)"
                      v-if="i > 0"
                    >
                      <span class="hmicon  hmicon icon-shanchu1 pointer"></span>
                    </div>
                    <div class="title">
                      {{ v.prizeName }}
                    </div>
                    <!-- <div
                      class="prize-name flex flex-column flex-center item-center"
                    >
                      <div>谢谢</div>
                      <div>惠顾</div>
                    </div> -->
                  </div>
                  <div class="frame_item lottery">
                    <img class=" grid-draw" :src="gameBgp3" />
                    <div class="upload-img" @click="toggleShowgameBgp3">
                      <span class="hmicon icon-shangchuantupian1"></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <template v-if="wheelType === 'roll'">
            <div
              class="roll-wheel-container prev-upload"
              :style="{ backgroundImage: 'url(' + gameBgp2 + ')' }"
            >
              <div
                class="upload-img"
                style="top:164px"
                @click="toggleShowgameBgp2"
              >
                <span class="hmicon icon-shangchuantupian1"></span>
              </div>
              <div
                class="upload-img"
                style="top:164px;left: 36px"
                @click="addChild"
              >
                <span class="hmicon icon-hao"></span>
              </div>
              <div class="flex times-wrapper  flex-center">
                <div class="changce flex item-center  flex-center">
                  <div class="changce-wrapper">
                    <span class="red-envelope"></span>
                    <span>你还有<span class="times">0</span>次抽奖机会</span>
                  </div>
                </div>
              </div>
              <div
                class="pointer prev-upload"
                :style="{ backgroundImage: 'url(' + gameBgp3 + ')' }"
              >
                <div
                  class="upload-img"
                  style="top: -36px"
                  @click="toggleShowgameBgp3"
                >
                  <span class="hmicon icon-shangchuantupian1"></span>
                </div>
              </div>
              <div class="roll-prize-wrapper flex item-center ">
                <!-- 老虎机 -->
                <div
                  id="rollList"
                  class="roll-list flex item-center prev-upload"
                >
                  <div
                    class="roll-item flex flex-column item-center flex-center prev-upload"
                    v-for="(v, i) in rule.turntablePrizeRuleList"
                    :key="i"
                  >
                    <div class="upload-img" @click="addGoodsImg(v, 'prizeImg')">
                      <span class="hmicon icon-shangchuantupian1"></span>
                    </div>
                    <div
                      class="delete-item"
                      @click="deleteChild(i)"
                      v-if="i > 0"
                    >
                      <span class="hmicon  hmicon icon-shanchu1"></span>
                    </div>
                    <div class="img-wrapper">
                      <img class="img" :src="v.prizeImg" mode="" />
                    </div>
                    <div class="prize-name">{{ v.prizeName }}</div>
                  </div>
                </div>
              </div>
              <div class="roll-lottery"></div>
            </div>
          </template>
        </div>
      </act-preview>
    </div>
    <div class="add-goods-container">
      <div class="act-step-wrapper">
        <hm-step
          :steps="steps"
          :scroll="true"
          :step="currentStep"
          @scroll="windowScroll"
        ></hm-step>
      </div>
      <div class="act-wrapper">
        <el-scrollbar :style="{ height: scrollHeight + 'px' }">
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="100px"
            class="product-ruleForm"
          >
            <div id="base">1.基本信息</div>
            <el-form-item label="活动标题" prop="gameName">
              <el-input
                style="width: 400px"
                size="small"
                clearable
                class="mr10 ipt"
                maxlength="25"
                v-model.trim="ruleForm.gameName"
                placeholder="请输入活动标题"
              ></el-input>
            </el-form-item>
            <el-form-item label="活动时间段选择" prop="activityDate">
              <el-date-picker
                :default-time="['00:00:00', '23:59:59']"
                v-model="ruleForm.activityDate"
                type="datetimerange"
                align="right"
                :picker-options="pickerOptions"
                start-placeholder="活动开始时间"
                end-placeholder="活动结束时间"
                value-format="yyyy-MM-dd HH:mm:ss"
                size="small"
                class="mr10"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="活动分享文案" prop="gameShareContent">
              <el-input
                :maxlength="30"
                style="width: 400px"
                size="small"
                clearable
                class="mr10 ipt"
                v-model.trim="ruleForm.gameShareContent"
                placeholder="请输入活动分享文案，30字以内"
              ></el-input>
            </el-form-item>
            <el-form-item label="背景音乐链接" prop="gameBgm">
              <el-input
                style="width: 400px"
                size="small"
                clearable
                class="mr10 ipt"
                v-model="ruleForm.gameBgm"
                placeholder="请输入音乐链接/音乐网络地址"
              ></el-input>
            </el-form-item>
            <el-form-item label="上传背景图" prop="mainImgUrl">
              <my-upload
                field="file"
                @crop-success="cropSuccess"
                @crop-upload-success="cropUploadSuccess"
                @crop-upload-fail="cropUploadFail"
                v-model="show"
                v-if="show"
                noCircle
                noSquare
                :width="750"
                :height="1334"
                :headers="{ 'X-Access-Token': $token }"
                :params="{ fileDir: 'mallDecoration' }"
                :url="$uploadUrl"
                img-format="png"
              ></my-upload>
              <!-- <el-button
                  type="primary"
                  size="small"
                  v-show="!listHeaderImgUrl"
                  @click="toggleShow"
                  >上传</el-button
                >-->
              <div class="flex upload-upload-btn">
                <div
                  class="btn flex flex-column flex-center open-file"
                  @click="toggleShow"
                  v-if="!listHeaderImgUrl"
                >
                  <div class="add-wrapper">
                    <span class="hmicon icon-hao pointer"></span>
                  </div>
                  <span>上传活动背景图</span>
                </div>
                <div v-if="listHeaderImgUrl" class="priview mr10 flex item-end">
                  <img :src="listHeaderImgUrl" alt="主图" />
                  <div class="opreat-wrapper flex item-center flex-center">
                    <el-button type="text" @click="toggleShow">更换</el-button>
                  </div>
                </div>
              </div>
              <span class="form-tip">图片尺寸建议750x1334（最多上传一张）</span>
            </el-form-item>

            <el-form-item :label="gameBgp2Name" prop="gameBgp2">
              <my-upload
                field="file"
                @crop-success="cropSuccess"
                @crop-upload-success="cropUploadSuccessBgp2"
                @crop-upload-fail="cropUploadFail"
                v-model="showgameBgp2"
                v-if="showgameBgp2"
                noCircle
                noSquare
                :width="gameBgp2UploadWidth"
                :height="gameBgp2UploadHeight"
                :headers="{ 'X-Access-Token': $token }"
                :params="{ fileDir: 'mallDecoration' }"
                :url="$uploadUrl"
                img-format="png"
              ></my-upload>

              <div class="flex upload-upload-btn">
                <div
                  class="btn flex flex-column flex-center open-file"
                  @click="toggleShowgameBgp2"
                  v-if="!gameBgp2"
                >
                  <div class="add-wrapper flex flex-center">
                    <span class="hmicon icon-hao pointer"></span>
                  </div>
                  <span>{{gameBgp2Name}}</span>
                </div>
                <div v-if="gameBgp2" class="priviewbgp2 mr10 flex item-end">
                  <img :src="gameBgp2" alt="转盘图" />
                  <div class="opreat-wrapper flex item-center flex-center">
                    <el-button type="text" @click="toggleShowgameBgp2"
                      >更换</el-button
                    >
                  </div>
                </div>
              </div>
              <span class="form-tip">图片尺寸建议{{gameBgp2UploadWidth}}x{{gameBgp2UploadHeight}}（最多上传一张）</span>
            </el-form-item>

            <el-form-item :label="gameBgp3Name" prop="gameBgp3">
              <my-upload
                field="file"
                @crop-success="cropSuccess"
                @crop-upload-success="cropUploadSuccessBgp3"
                @crop-upload-fail="cropUploadFail"
                v-model="showgameBgp3"
                noCircle
                noSquare
                :width="gameBgp3UploadWidth"
                :height="gameBgp3UploadWidth"
                :headers="{ 'X-Access-Token': $token }"
                :params="{ fileDir: 'mallDecoration' }"
                :url="$uploadUrl"
                img-format="png"
              ></my-upload>
              <div class="flex upload-upload-btn">
                <div
                  class="btn flex flex-column flex-center open-file"
                  @click="toggleShowgameBgp3"
                  v-if="!gameBgp3"
                >
                  <div class="add-wrapper">
                    <span class="hmicon icon-hao pointer"></span>
                  </div>
                  <span>{{gameBgp3Name}}</span>
                </div>
                <div v-if="gameBgp3" class="priviewbgp3 mr10 flex item-end">
                  <img :src="gameBgp3" alt="主图" />
                  <div class="opreat-wrapper flex item-center flex-center">
                    <el-button type="text" @click="toggleShowgameBgp3"
                      >更换</el-button
                    >
                  </div>
                </div>
              </div>
              <span class="form-tip">图片尺寸建议{{gameBgp3UploadWidth}}x{{gameBgp3UploadHeight}}（最多上传一张）</span>
            </el-form-item>

            <el-form-item label="活动规则说明" prop="gameRuleRemark">
              <hm-rich-editor
                v-model="ruleForm.gameRuleRemark"
                :html="ruleForm.gameRuleRemark"
              />
            </el-form-item>

            <el-form-item label="虚拟参与人数" prop="visualJoinNum">
              <span>在实际参与人数基础上增加</span>
              <el-input
                @mousewheel.prevent.native
                type="number"
                style="width: 100px"
                size="small"
                clearable
                class="mr10 ipt"
                v-model.trim="ruleForm.visualJoinNum"
                placeholder="请输入数字"
              ></el-input
              >人
              <div class="form-tip">
                显示在手机端，已参与活动人数=实际参与人数加上此处设置的虚拟人数
              </div>
            </el-form-item>
            <div id="gameRule">{{ steps.length === 3 ? 2 : 2 }}活动规则</div>

            <el-form-item label="抽奖限制" prop="drawType">
              <template>
                <div>
                  <el-radio v-model="rule.drawType" label="total">
                    <span>总抽奖限制,限制活动时间,每人最多抽奖</span>
                    <el-input
                      type="number"
                      @mousewheel.prevent.native
                      :disabled="rule.drawType !== 'total'"
                      style="width: 100px"
                      size="small"
                      clearable
                      class="mr10 ipt"
                      v-model.trim="rule.drawPrizeNumTotal"
                      placeholder="请输入数字"
                    ></el-input>
                    <span>次,每人中奖上限</span>
                    <el-input
                      type="number"
                      @mousewheel.prevent.native
                      :disabled="rule.drawType !== 'total'"
                      style="width: 100px"
                      size="small"
                      clearable
                      class="mr10 ipt"
                      v-model.trim="rule.eachWinningUpperLimitTotal"
                      placeholder="请输入数字"
                    ></el-input>
                  </el-radio>
                </div>
                <div>
                  <el-radio v-model="rule.drawType" label="daily">
                    <span>每日抽奖限制,每人每日抽奖</span>
                    <el-input
                      type="number"
                      @mousewheel.prevent.native
                      :disabled="rule.drawType !== 'daily'"
                      style="width: 100px"
                      size="small"
                      clearable
                      class="mr10 ipt"
                      v-model.trim="rule.drawPrizeNumDaily"
                      placeholder="请输入数字"
                    ></el-input>
                    <span>次,每人中奖上限</span>
                    <el-input
                      type="number"
                      @mousewheel.prevent.native
                      :disabled="rule.drawType !== 'daily'"
                      style="width: 100px"
                      size="small"
                      clearable
                      class="mr10 ipt"
                      v-model.trim="rule.eachWinningUpperLimitDaily"
                      placeholder="请输入数字"
                    ></el-input>
                  </el-radio>
                </div>
                <div class="form-tip">
                  达到抽奖上限次数将不能参加抽奖，达到中奖上限将不再获得奖品
                </div>
              </template>
            </el-form-item>
            <el-form-item label="活动奖品设置" prop="drawTypeList">
              <div
                class="form-tips"
                style="color: #e50163; font-size: 12px"
                v-if="wheelType === 'grid'"
              >
                九宫格转盘只能添加7个商品，少于7个商品的部分在小程序将被谢谢惠顾填充
              </div>


              <div style="width: 1400px;">
              <el-table
                :data="rule.turntablePrizeRuleList"
                style="width: 100%"
                ref="table"
                border
                stripe
                size="small"
              >
                <el-table-column
                  header-align="center"
                  align="center"
                  label="奖项"
                  prop="rankingSeqNum"
                >
                  <template slot-scope="scope">
                    <div class="p10">
                      <el-input
                        size="small"
                        clearable
                        class="ipt"
                        maxlength="60"
                        style="width:100%"
                        v-model.trim="scope.row.rankingSeqNum"
                        placeholder="请输入奖项"
                      ></el-input>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  label="奖品类型"
                  prop="prizeType"
                >
                  <template slot-scope="scope">
                    <div class="p10">
                      <el-select
                        clearable
                        size="small"
                        style="width:100%"
                        v-model="scope.row.prizeType"
                        placeholder="请选择奖品类型"
                      >
                        <el-option label="积分" value="1"></el-option>
                        <el-option label="优惠劵" value="2"></el-option>
                        <el-option label="实物" value="3"></el-option>
                      </el-select>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  label="奖品内容"
                  prop="prizeType"
                >
                  <template slot-scope="scope">
                    <div class="p10">
                      <el-input
                        type="number"
                        @mousewheel.prevent.native
                        v-if="scope.row.prizeType == '1'"
                        style="width:100%"
                        v-model.trim="scope.row.typeValue"
                        @input="filterGt0OrFixed('typeValue', scope.$index)"
                        size="small"
                        clearable
                        placeholder="奖品积分"
                      ></el-input>
                      <el-input
                        v-if="scope.row.prizeType == '3'"
                        style="width:100%"
                        v-model.trim="scope.row.typeValue"
                        size="small"
                        clearable
                        placeholder="实物名称"
                      ></el-input>
                      <el-select
                        v-if="scope.row.prizeType == '2'"
                        clearable
                        size="small"
                        style="width:100%"
                        v-model="scope.row.typeValue"
                        placeholder="请选择优惠券"
                      >
                        <el-option
                          :label="item.name"
                          :value="item.couponSendId"
                          v-for="(item, i) in couponList"
                          :key="i"
                        ></el-option>
                      </el-select>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  label="奖品名称"
                  prop="prizeName"
                >
                  <template slot-scope="scope">
                    <div class="p10">
                      <el-input
                        size="small"
                        clearable
                        class="ipt"
                        maxlength="60"
                        style="width:100%"
                        v-model.trim="scope.row.prizeName"
                        placeholder="奖品名称"
                      ></el-input>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  label="奖品图片"
                  prop="prizeName"
                >
                  <template slot-scope="scope">
                    <div class="flex flex-center">
                      <div
                        class="flex goods-upload-btn"
                        @click="addGoodsImg(scope.row, 'prizeImg')"
                        v-if="!scope.row.prizeImg"
                      >
                        <div
                          style="margin-left:0px"
                          class="btn flex flex-column flex-center open-file item-center"
                        >
                          <div class="add-prize-img-wrapper">
                            <span class="hmicon icon-hao pointer"></span>
                          </div>
                          <span>添加图片</span>
                        </div>
                      </div>
                      <div v-else class="mr10 flex item-end priviews">
                        <!-- <img class="logo" :src="scope.row.prizeImg" alt="logo" /> -->
                        <el-image
                          class="img"
                          :src="scope.row.prizeImg"
                          alt="logo"
                          :preview-src-list="[scope.row.prizeImg]"
                        />
                        <div
                          class="opreat-wrapper flex item-center flex-center"
                        >
                          <el-button
                            type="text"
                            @click="handleRemove(scope.$index)"
                            >删除</el-button
                          >
                        </div>
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  label="奖品数量"
                  prop="prizeNum"
                >
                  <template slot-scope="scope">
                    <div class="p10">
                      <el-input
                        size="small"
                        clearable
                        class="ipt"
                        maxlength="60"
                        style="width:100%"
                        v-model.trim="scope.row.prizeNum"
                        placeholder="请输入数量"
                      ></el-input>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  label="单人中奖上限"
                  prop="eachPrizeWinningUpperLimit"
                >
                  <template slot-scope="scope">
                    <div class="p10">
                      <el-input
                        size="small"
                        clearable
                        class="ipt"
                        maxlength="60"
                        style="width:100%"
                        @input="filterGt0OrFixed22(scope.$index, 'eachPrizeWinningUpperLimit')"
                        v-model.trim="scope.row.eachPrizeWinningUpperLimit"
                        placeholder="请输入单人中奖上限"
                      ></el-input>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="winningRate"
                >
                  <template slot="header">
                    <span class="mr10">中奖率</span>
                    <el-popover
                      placement="top-start"
                      width="200"
                      trigger="hover"
                    >
                      <div>
                        中奖率合计不能超过100%
                      </div>
                      <span slot="reference">
                        <i class="el-icon-question" style="fontSize:20px"></i>
                      </span>
                    </el-popover>
                  </template>
                  <template slot-scope="scope">
                    <div class="flex item-center p10">
                      <el-input
                        size="small"
                        clearable
                        class="ipt"
                        maxlength="18"
                        style="width:100%"
                        @input="filterGt0OrFixed22(scope.$index, 'winningRate')"
                        v-model.trim="scope.row.winningRate"
                        placeholder="中奖率"
                      ></el-input
                      >%
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  label="出奖门槛（总抽奖数到达多少次）"
                  prop="awardThreshold"
                >
                  <template slot-scope="scope">
                    <div class="flex item-center">
                      <el-input
                        size="small"
                        clearable
                        class="mr10 ml10 ipt"
                        maxlength="18"
                        style="width:100px"
                        @input="
                          filterGt0OrFixed0(scope.$index, 'awardThreshold')
                        "
                        v-model.trim="scope.row.awardThreshold"
                        placeholder="请输入数字"
                      ></el-input>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="orderSn"
                  label="操作"
                  width="80px"
                >
                  <template slot-scope="scope">
                    <div class="flex flex-center">
                      <div
                        style="margin-left:0px"
                        class="add-wrapper flex flex-center"
                        v-if="scope.$index === 0"
                      >
                        <span
                          class="hmicon icon-hao pointer"
                          @click="addChild(scope.$index)"
                        ></span>
                      </div>
                      <div
                        style="margin-left:0px"
                        class="minus-wrapper flex flex-center"
                        v-else
                      >
                        <span
                          class="hmicon icon-jianhao pointer"
                          @click="deleteChild(scope.$index)"
                        ></span>
                      </div>
                    </div>
                  </template>
                </el-table-column>
              </el-table>

              </div>



              <!-- <div class="table game-select">
                <div class="table-header flex">
                  <div class="flex-1 text-center">奖项</div>
                  <div class="flex-1 text-center">奖品类型</div>
                  <div class="flex-1 text-center">奖品内容</div>
                  <div class="flex-1 text-center">奖品名称</div>
                  <div class="flex-1 text-center">奖品图片</div>
                  <div class="flex-1 text-center">奖品数量</div>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="数字越小，代表优先级越高，则优先出此奖项。如，一等奖优先级为3，二等奖优先级为2,三等奖优先级为1,则先出三等奖，再出二等奖，最后出一等奖"
                    placement="top"
                  >
                    <div class="flex-1 text-center primary">优先级</div>
                  </el-tooltip>
                  <div class="flex-1 text-center">操作</div>
                </div>
                <div class="table-body">
                  <div
                    class="flex table-row item-center"
                    v-for="(item, index) in rule.turntablePrizeRuleList"
                    :key="index"
                  >
                    <div class="flex-1 text-center">
                      <el-input
                        style="width: 100px"
                        v-model.trim="item.rankingSeqNum"
                        size="small"
                      ></el-input>
                    </div>
                    <div class="flex-1 text-center">
                      <el-select
                        clearable
                        size="small"
                        v-model="item.prizeType"
                        placeholder="请选择奖品类型"
                      >
                        <el-option label="积分" value="1"></el-option>
                        <el-option label="优惠劵" value="2"></el-option>
                        <el-option label="实物" value="3"></el-option>
                      </el-select>
                    </div>
                    <div class="flex-1 text-center">
                      <el-input
                        type="number"
                        @mousewheel.prevent.native
                        v-if="item.prizeType == '1'"
                        style="width: 140px"
                        v-model.trim="item.typeValue"
                        @input="filterGt0OrFixed('typeValue', index)"
                        size="small"
                        clearable
                        placeholder="奖品积分"
                      ></el-input>
                      <el-input
                        v-if="item.prizeType == '3'"
                        style="width: 140px"
                        v-model.trim="item.typeValue"
                        size="small"
                        clearable
                        placeholder="实物名称"
                      ></el-input>
                      <el-select
                        v-if="item.prizeType == '2'"
                        clearable
                        size="small"
                        v-model="item.typeValue"
                        placeholder="请选择优惠券"
                      >
                        <el-option
                          :label="item.name"
                          :value="item.couponSendId"
                          v-for="(item, i) in couponList"
                          :key="i"
                        ></el-option>
                        
                      </el-select>
                    </div>
                    <div class="flex-1 text-center">
                      <el-input
                        style="width: 140px"
                        v-model.trim="item.prizeName"
                        size="small"
                        clearable
                        placeholder="奖品名称"
                      ></el-input>
                    </div>
                    <div
                      class="flex-1 text-center flex flex-center item-center"
                    >
                      <div
                        class="flex goods-upload-btn"
                        @click="addGoodsImg(item, 'prizeImg')"
                      >
                        <div
                          class="btn flex flex-column flex-center open-file item-center"
                          v-if="!item.prizeImg"
                        >
                          <div class="add-prize-img-wrapper">
                            <span class="hmicon icon-hao pointer"></span>
                          </div>
                          <span>添加图片</span>
                        </div>
                        <div v-if="item.prizeImg" class="mr10 flex item-end">
                          <img class="logo" :src="item.prizeImg" alt="logo" />
                        </div>
                      </div>
                      <my-upload
                        field="file"
                        @crop-success="cropSuccess"
                        @crop-upload-success="cropUploadSuccess"
                        @crop-upload-fail="cropUploadFail"
                        v-model="showPrizeImg"
                        noCircle
                        noSquare
                        :width="100"
                        :height="100"
                        :headers="{ 'X-Access-Token': $token }"
                        :params="{ fileDir: 'goodsCenter' }"
                        :url="$uploadUrl"
                        img-format="png"
                      ></my-upload>
                    </div>
                    <div class="flex-1 text-center">
                      <el-input
                        type="number"
                        @mousewheel.prevent.native
                        @input="filterGt0OrFixed('prizeNum', index)"
                        style="width: 100px"
                        v-model.trim="item.prizeNum"
                        size="small"
                        placeholder="请输入数量"
                      ></el-input>
                    </div>

                    <div class="flex-1 text-center">
                      <el-input
                        type="number"
                        @mousewheel.prevent.native
                        style="width: 100px"
                        v-model.trim="item.prizePriority"
                        @input="filterGt0OrFixed('prizePriority', index)"
                        size="small"
                        placeholder="请输入数字"
                      ></el-input>
                    </div>
                    <div class="flex-1">
                      <div
                        class="add-wrapper flex flex-center"
                        style="margin-left:0px"
                        v-if="index === 0"
                      >
                        <span
                          class="hmicon icon-hao pointer"
                          @click="addChild(index)"
                        ></span>
                      </div>
                      <div class="minus-wrapper flex flex-center" v-else>
                        <span
                          class="hmicon icon-jianhao pointer"
                          @click="deleteChild(index)"
                        ></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div> -->
            </el-form-item>
            <!-- <el-form-item label="预计参与次数" prop="estimatedNum">
              <el-input
                type="number"
                @mousewheel.prevent.native
                style="width: 100px"
                size="small"
                clearable
                class="mr10 ipt"
                v-model.trim="ruleForm.estimatedNum"
                @input="filterGt0OrFixed2('estimatedNum')"
                placeholder="请输入次数"
              ></el-input
              >次
              <div class="form-tip">
                预计参与次数，将直接影响中奖概率，中奖概率=奖品数量/(奖品数量总和+预计参与次数)
              </div>
            </el-form-item> -->
            <div id="gameAstrict">{{ steps.length === 3 ? 3 : 3 }}活动限制</div>
            <el-form-item label="活动参与门槛" prop="eachConsumIntegral">
              <span>每次消耗积分</span>
              <el-input
                type="number"
                @mousewheel.prevent.native
                style="width: 130px"
                size="small"
                clearable
                class="mr10 ipt"
                v-model.trim="threshold.eachConsumIntegral"
                @input="filterGt0OrFixed3('eachConsumIntegral')"
                placeholder="请输入积分数值"
              ></el-input>
            </el-form-item>
            <div class="flex flex-center">
              <el-button
                type="primary"
                size="small"
                @click="submitForm('ruleForm')"
                >发布</el-button
              >
              <el-button size="small" @click="$router.back(-1)">返回</el-button>
            </div>
          </el-form>
          <!-- <div class="pvw flex flex-between">
            <div class="flex-4">
            </div>
            <div class="text-center flex-1">
              <el-button
                class="fixed-but"
                size="small"
                type="danger"
                round
                @click="minimum"
                v-if="isCollapse"
              >
                <span class="hmicon icon-shouji"></span>
                <span>{{ isCollapse ? "点击展开" : "点击隐藏" }}</span>
                <span class="hmicon icon-youshuangjiantou arrow"></span>
              </el-button>
              <el-button
                v-else
                class="fixed-but"
                size="small"
                type="primary"
                round
                @click="minimum"
              >
                <span class="hmicon icon-shouji"></span>
                <span>{{ isCollapse ? "点击展开" : "点击隐藏" }}</span>
                <span class="hmicon icon-youshuangjiantou arrow"></span>
              </el-button>
            </div>
           
          </div> -->

          <div class></div>
        </el-scrollbar>
        <my-upload
          field="file"
          @crop-success="cropSuccess"
          @crop-upload-success="cropUploadSuccess"
          @crop-upload-fail="cropUploadFail"
          v-model="showPrizeImg"
          v-if="showPrizeImg"
          noCircle
          noSquare
          :width="100"
          :height="100"
          :headers="{ 'X-Access-Token': $token }"
          :params="{ fileDir: 'goodsCenter' }"
          :url="$uploadUrl"
          img-format="png"
        ></my-upload>
      </div>
      <!-- <el-dialog
        :close-on-click-modal="false"
        title="批量设置"
        :visible.sync="dialogVisible"
      >
        <div class=" flex flex-center">
          <div id="audio_btn" class="rotate">
            <audio
              :src="ruleForm.gameBgm"
              autoplay="true"
              loop="loop"
              id="audio1"
              preload="true"
            ></audio>
          </div>
          <img
            class="pvwimg"
            style="width:400px;height:667px"
            :src="listHeaderImgUrl"
            alt=""
          />
          <p>已有 {{ 0 }}人参与</p>
          <p>您今天还有 {{ 3 }}次抽奖机会</p>
        </div>
        <div class="btn-wrapper flex flex-center">
          <el-button size="small" @click="dialogVisible = false"
            >取 消</el-button
          >
        </div>
      </el-dialog>-->
    </div>
  </div>
</template>

<script>
import HmStep from "@/components/HmStep";
import myUpload from "vue-image-crop-upload";
import HmRichEditor from "@/components/HmRichEditor";
import actPreview from "@/components/actPreview";

export default {
  components: {
    HmStep,
    myUpload,
    HmRichEditor,
    actPreview
  },
  data() {
    // const actDate = function(rule, val, callback) {
    //   // if (val > +this.ruleForm.actMemberUpperLimit) {
    //   //   return callback(new Error("已报名人数不能大于活动人数上限"));
    //   // }
    //   // const endTime = new Date(val[0]);
    //   // const nowTime = new Date();
    //   // let leftTime = parseInt((endTime.getTime() - nowTime.getTime()) / 1000);
    //   // if (leftTime < 0) {
    //   //   this.start = false;
    //   // } else {
    //   //   this.start = true;
    //   // }
    //   callback();
    // }.bind(this);
    const patterndRuleRemarkFunc = function(rule, val, callback) {
      if (!this.ruleForm.gameRuleRemark) {
        return callback(new Error("请输入活动规则说明"));
      }
      callback();
    }.bind(this);
    const patterndImgFunc = function(rule, val, callback) {
      if (!this.listHeaderImgUrl) {
        return callback(new Error("请选择主图"));
      }
      callback();
    }.bind(this);
    const patterndgameBgp2Func = function(rule, val, callback) {
      if (!this.gameBgp2) {
        return callback(new Error("请选择转盘图"));
      }
      callback();
    }.bind(this);
    const patterndgameBgp3Func = function(rule, val, callback) {
      if (!this.gameBgp3) {
        return callback(new Error("请选择指针图"));
      }
      callback();
    }.bind(this);
    const patterndEachConsumIntegralFunc = function(rule, val, callback) {
      if (!this.threshold.eachConsumIntegral) {
        return callback(new Error("请填写每次消耗积分"));
      }
      callback();
    }.bind(this);
    const patterndRawTypeFunc = function(rule, val, callback) {
      if (this.rule.drawType === "total") {
        if (
          this.rule.drawPrizeNumTotal &&
          this.rule.eachWinningUpperLimitTotal
        ) {
          callback();
        } else {
          return callback(new Error("请填写所有项"));
        }
      } else {
        if (
          this.rule.eachWinningUpperLimitDaily &&
          this.rule.drawPrizeNumDaily
        ) {
          callback();
        } else {
          return callback(new Error("请填写所有项"));
        }
      }
      callback();
    }.bind(this);
    const patterndDrawTypeListFunc = function(rule, val, callback) {
      let flag = true;
      let winningRateTotal = 0;
      this.rule.turntablePrizeRuleList.map(v => {
        if (
          !v.rankingSeqNum ||
          !v.prizeType ||
          !v.typeValue ||
          !v.prizeName ||
          !v.prizeNum ||
          !v.eachPrizeWinningUpperLimit ||
          (!v.winningRate && v.winningRate != 0)
        ) {
          flag = false;
        }
        winningRateTotal += v.winningRate * 1;
      });
      if (flag) {
        if (winningRateTotal > 100) {
          return callback(new Error("中奖率合计不能超过100%!"));
        }
        callback();
      } else {
        return callback(new Error("请填写所有项"));
      }
    }.bind(this);
    return {
      pickerOptions: {
        disabledDate(time) {
          let curDate = new Date().getTime();
          // 这里算出一个月的毫秒数,这里使用30的平均值,实际中应根据具体的每个月有多少天计算
          let day = 365 * 24 * 3600 * 1000;
          let dateRegion = curDate + day;
          return (
            time.getTime() < Date.now() - 8.64e7 || time.getTime() > dateRegion
          );
        }
      },
      rotateDeg: 0,
      isPlaying: false,
      gameBgp2:
        "https://imgcdn.hemiao100.com/hemiaoBase/turnTable/%E8%B5%84%E6%BA%90%201.png",
      gameBgp3:
        "https://imgcdn.hemiao100.com/hemiaoBase/turnTable/%E8%BD%AC%E7%9B%98-06.png",
      listHeaderImgUrl:
        "https://imgcdn.hemiao100.com/hemiaoBase/turnTable/%E6%9C%AA%E6%A0%87%E9%A2%98-1.png",
      gridBg:
        "https://imgcdn.hemiao100.com/hemiaoBase/hmService/wheelAct-gridBg.png",
      rollBg:
        "https://imgcdn.hemiao100.com/decoration/ps8cebd012a8481faf-8ef1-4501-9294-4b963ab597f7.png",
      rollCircleBg:
        "https://imgcdn.hemiao100.com/decoration/ps89dbc6bf3a87a4d5-e0ea-46f0-bd1b-67be1c617d2c.png",
      gridCircleBg:
        "https://imgcdn.hemiao100.com/hemiaoBase/hmService/wheelAct-gridCircleBg.png",
      gridPointerBg:
        "https://imgcdn.hemiao100.com/mall/ps903789aaa93f578f-28ce-47e7-bfbd-37af592f9be1.png",
      rollPointerBg:
        "https://imgcdn.hemiao100.com/decoration/ps880204674c532487-4cd4-4d19-a6ab-6b006768935e.png",
      storeId: "",
      currentGoods: {},
      currentStep: 1,
      scrollHeight: 0,
      show: false,
      showgameBgp2: false,
      showgameBgp3: false,
      dialogVisible: false,
      couponList: [],
      steps: [
        {
          id: "base",
          name: "基本信息"
        },
        {
          id: "gameRule",
          name: "活动规则"
        },
        {
          id: "gameAstrict",
          name: "活动限制"
        }
      ],
      ruleForm: {
        gameName: "",
        gameRuleRemark: "",
        gameShareContent: "",
        gameBgm: "",
        estimatedNum: "",
        visualJoinNum: "0",
        activityDate: []
      },
      uploadType: "",
      wheelType: "",
      rule: {
        uiType: "",
        estimatedNum: "",
        drawPrizeNumTotal: "",
        eachWinningUpperLimitTotal: "",
        drawPrizeNumDaily: "",
        eachWinningUpperLimitDaily: "",
        drawType: "total",
        turntablePrizeRuleList: [
          {
            rankingSeqNum: "",
            prizeType: "1",
            typeValue: "",
            prizeName: "",
            prizeNum: "",
            prizePriority: "",
            prizeImg: "",
            winningRate: "",
            awardThreshold: 0,
            eachPrizeWinningUpperLimit: "",
          }
        ]
      },
      showPrizeImg: false,
      threshold: {
        eachConsumIntegral: ""
      },
      rules: {
        visualJoinNum: [
          {
            pattern: /^[0-9]\d*$/,
            message: "请输入正整数",
            trigger: "blur"
          },
          {
            required: true,
            message: "请输入虚拟参与人数",
            trigger: "blur"
          }
        ],
        gameName: [
          {
            required: true,
            message: "请输入活动标题",
            trigger: "blur"
          },
          {
            min: 2,
            max: 20,
            message: "长度在 2 到 20 个字符",
            trigger: "blur"
          }
        ],
        activityDate: {
          // validator: actDate,
          message: "请选择活动时间段",
          trigger: "blur",
          required: true
        },
        gameShareContent: [
          {
            required: true,
            message: "请输入活动分享文案",
            trigger: "blur"
          }
        ],
        mainImgUrl: [
          {
            required: true,
            validator: patterndImgFunc,
            trigger: "blur"
          }
        ],
        gameBgp2: [
          {
            required: true,
            validator: patterndgameBgp2Func,
            trigger: "blur"
          }
        ],
        gameBgp3: [
          {
            required: true,
            validator: patterndgameBgp3Func,
            trigger: "blur"
          }
        ],
        gameRuleRemark: [
          {
            required: true,
            validator: patterndRuleRemarkFunc,

            trigger: "blur"
          }
        ],
        drawType: [
          {
            required: true,
            validator: patterndRawTypeFunc,
            trigger: "change"
          }
        ],
        drawTypeList: [
          {
            required: true,
            validator: patterndDrawTypeListFunc,
            trigger: "blur"
          }
        ],
        estimatedNum: [
          {
            required: true,
            message: "请填写预计参与次数",
            trigger: "blur"
          }
        ],
        eachConsumIntegral: [
          {
            required: true,
            validator: patterndEachConsumIntegralFunc,
            trigger: "blur"
          }
        ]
      },
      actDesc: {},
      isCollapse: true,
      gameBgp2Name: "",
      gameBgp3Name: "",
      gameBgp2UploadWidth:0,
      gameBgp2UploadHeight:0,
      gameBgp3UploadWidth:0,
      gameBgp3UploadHeight:0,
    };
  },
  computed: {
    len() {
      return this.rule.turntablePrizeRuleList.length;
    },
    turnNum() {
      return 1 / this.len;
    }
  },
  watch: {
    "rule.drawType": {
      handler(val) {
        if (val === "daily") {
          this.rule.drawPrizeNumTotal = "";
          this.rule.eachWinningUpperLimitTotal = "";
        } else {
          this.rule.eachWinningUpperLimitDaily = "";
          this.rule.drawPrizeNumDaily = "";
        }
      },
      deep: true
    }
  },
  created() {
    this.wheelType = this.$route.query.wheelType;    
    this.setWheelType(this.$route.query.wheelType);
    this.getImageSize();
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll, true);
    window.addEventListener("resize", this.handleResize, true);
    this.calcHeight();
    this.$store.dispatch("findCouponSendByEvent").then(res => {
      if (res.code === "0") {
        this.couponList = res.result;
      }
    });
    if (this.$route.query.gameId) {
      this.activityDetail().then(res => {
        this.ruleForm.activityDate = [
          res.result.gameStartTime,
          res.result.gameEndTime
        ];
        this.listHeaderImgUrl = res.result.gameBgp;
        this.gameBgp2 = res.result.gameBgp2;
        this.gameBgp3 = res.result.gameBgp3;
        if (res.result.rule) {
          this.rule.drawType = res.result.rule.drawType;
          this.rule.turntablePrizeRuleList =
            res.result.rule.turntablePrizeRuleList;
          if (res.result.rule.drawType == "daily") {
            this.rule.drawPrizeNumDaily = res.result.rule.drawPrizeNum;
            this.rule.eachWinningUpperLimitDaily =
              res.result.rule.eachWinningUpperLimit;
          } else {
            this.rule.drawPrizeNumTotal = res.result.rule.drawPrizeNum;
            this.rule.uiType = res.result.rule.uiType;
            this.wheelType = res.result.rule.uiType;
            this.getImageSize();
            this.rule.eachWinningUpperLimitTotal =
              res.result.rule.eachWinningUpperLimit;
          }
        }

        for (let key in res.result) {
          this.ruleForm[key] = res.result[key];
        }
        this.ruleForm.estimatedNum = res.result.rule.estimatedNum;

        if (res.result.threshold) {
          this.threshold.eachConsumIntegral =
            res.result.threshold.eachConsumIntegral;
        }
        this.rule.turntablePrizeRuleList.forEach(v => {
          if (v.prizeType === "2") {
            v.typeValue = "";
          }
        });
      });
    }
  },
  destroyed: function() {
    window.removeEventListener("scroll", this.handleScroll); //  离开页面清除（移除）滚轮滚动事件
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    filterGt0OrFixed22(index, prop) {
      this.rule.turntablePrizeRuleList[index][
        prop
      ] = this.rule.turntablePrizeRuleList[index][prop].replace(/[^\d.]/g, ""); //仅保留数字和"."
      this.rule.turntablePrizeRuleList[index][
        prop
      ] = this.rule.turntablePrizeRuleList[index][prop].replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
      this.rule.turntablePrizeRuleList[index][
        prop
      ] = this.rule.turntablePrizeRuleList[index][prop]
        .replace(".", "$#*")
        .replace(/\./g, "")
        .replace("$#*", "."); //去除其他"."
      this.rule.turntablePrizeRuleList[index][
        prop
      ] = this.rule.turntablePrizeRuleList[index][prop].replace(
        /^(\d+)\.(\d\d).*$/,
        "$1.$2"
      ); //限制只能输入两个小数
      if (
        this.rule.turntablePrizeRuleList[index][prop].indexOf(".") < 0 &&
        this.rule.turntablePrizeRuleList[index][prop] != ""
      ) {
        //首位是0的话去掉
        this.rule.turntablePrizeRuleList[index][prop] = parseFloat(
          this.rule.turntablePrizeRuleList[index][prop]
        );
      }
    },
    filterGt0OrFixed0(index, prop) {
      // this.rule.turntablePrizeRuleList[index][
      //   prop
      // ] = this.rule.turntablePrizeRuleList[index][prop].replace(/^(0+)/, ""); //过滤0开头
      this.rule.turntablePrizeRuleList[index][
        prop
      ] = this.rule.turntablePrizeRuleList[index][prop].replace(/[^\d]/g, "");
      this.rule.turntablePrizeRuleList[index][
        prop
      ] = this.rule.turntablePrizeRuleList[index][prop]
        .replace(".", "")
        .replace("-", "")
        .replace(",", "");
      // console.log(this.rule.turntablePrizeRuleList[index][prop]);
      this.rule.turntablePrizeRuleList[index][prop] = new Number(
        this.rule.turntablePrizeRuleList[index][prop]
      );
    },
    setWheelType(type) {
      switch (type) {
        case "grid":
          this.listHeaderImgUrl = this.gridBg;
          this.gameBgp2 = this.gridCircleBg;
          this.gameBgp3 = this.gridPointerBg;
          break;
        case "roll":
          this.listHeaderImgUrl = this.rollBg;
          this.gameBgp2 = this.rollCircleBg;
          this.gameBgp3 = this.rollPointerBg;
          break;
        default:
          break;
      }
    },
    addGoodsImg(v, type) {
      this.uploadType = type;
      this.showPrizeImg = !this.showPrizeImg;
      this.currentGoods = v;
    },
    activityDetail() {
      const { gameId } = this.$route.query;

      const params = {
        gameId
      };
      return this.$store.dispatch("queryActivitDetail", params);
    },
    cropSuccess() {},
    cropUploadFail() {},
    cropUploadSuccess(jsonData) {
      if (this.showPrizeImg) {
        this.currentGoods.prizeImg = jsonData.result;
        this.showPrizeImg = false;
        console.log("this.currentGoods: ", this.currentGoods);
        return;
      }
      if (this.show) {
        this.listHeaderImgUrl = jsonData.result;
        this.show = false;
      }
    },
    cropUploadSuccessBgp2(jsonData) {
      if (this.showgameBgp2) {
        this.gameBgp2 = jsonData.result;
      }
    },
    cropUploadSuccessBgp3(jsonData) {
      this.gameBgp3 = jsonData.result;
    },
    windowScroll(i) {
      this.$nextTick(() => {
        document.getElementById(this.steps[i].id).scrollIntoView();
        this.currentStep = i + 1;
      });
    },
    toggleShow() {
      this.show = !this.show;
    },
    toggleShowgameBgp2() {
      this.showgameBgp2 = !this.showgameBgp2;
    },
    toggleShowgameBgp3() {
      this.showgameBgp3 = !this.showgameBgp3;
    },
    handleResize() {
      this.calcHeight();
    },
    calcHeight() {
      setTimeout(() => {
        const headerHeight = document.querySelector(".navbar")
          ? document.querySelector(".navbar").getBoundingClientRect().y
          : 0;
        const tagHeight = document.querySelector(".tags-view-container")
          ? document
              .querySelector(".tags-view-container")
              .getBoundingClientRect().y
          : 0;
        const stepsHeight = document.querySelector(".step-wrapper")
          ? document.querySelector(".step-wrapper").getBoundingClientRect().y
          : 0;
        const footerHeight = document.querySelector(".el-footer")
          ? document.querySelector(".el-footer").getBoundingClientRect().height
          : 0;
        this.scrollHeight =
          window.innerHeight -
          headerHeight -
          tagHeight -
          stepsHeight -
          footerHeight -
          80;
      }, 0);
    },
    handleScroll(e) {
      this.steps.map((v, i) => {
        const ele = document.getElementById(v.id);
        if (ele) {
          const offsetTop = ele.offsetTop;
          if (e.target.scrollTop + 360 > offsetTop) {
            this.currentStep = i + 1;
          } else if (e.target.scrollTop < 100) {
            this.currentStep = 1;
          } else {
            this.currentStep = i - 1;
          }
        }
      });
    },
    addChild() {
      if (
        this.wheelType === "grid" &&
        this.rule.turntablePrizeRuleList.length >= 7
      ) {
        this.$message({
          message: "九宫格转盘只能添加7个商品",
          type: "warning"
        });
        return;
      }
      this.rule.turntablePrizeRuleList.push({
        rankingSeqNum: "",
        prizeType: "1",
        typeValue: "",
        prizeName: "",
        prizeNum: "",
        prizePriority: "",
        prizeImg: "",
        winningRate: "",
        awardThreshold: 0,
        eachPrizeWinningUpperLimit: "",
      });
    },
    filterGt0OrFixed(prop, i) {
      this.rule.turntablePrizeRuleList[i][
        prop
      ] = this.rule.turntablePrizeRuleList[i][prop].replace(/^(0+)/, ""); //过滤0开头
      this.rule.turntablePrizeRuleList[i][
        prop
      ] = this.rule.turntablePrizeRuleList[i][prop]
        .replace(".", "")
        .replace("-", "");

      this.rule.turntablePrizeRuleList[i][
        prop
      ] = this.rule.turntablePrizeRuleList[i][prop].replace(/\.{2,}/g, ""); //两个连续的"."仅保留第一个"."
    },
    filterGt0OrFixed2(prop) {
      // this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)/, ""); //过滤0开头
      this.ruleForm[prop] = this.ruleForm[prop]
        .replace(".", "")
        .replace("-", "");

      this.ruleForm[prop] = this.ruleForm[prop].replace(/\.{2,}/g, ""); //两个连续的"."仅保留第一个"."
    },
    filterGt0OrFixed3(prop) {
      // this.threshold[prop] = this.threshold[prop].replace(/^(0+)/, ""); //过滤0开头
      this.threshold[prop] = this.threshold[prop]
        .replace(".", "")
        .replace("-", "");

      this.threshold[prop] = this.threshold[prop].replace(/\.{2,}/g, ""); //两个连续的"."仅保留第一个"."
    },
    deleteChild(index) {
      this.rule.turntablePrizeRuleList.splice(index, 1);
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.ruleForm.gameStartTime =
            this.ruleForm.activityDate && this.ruleForm.activityDate.length > 0
              ? this.ruleForm.activityDate[0]
              : "";
          this.ruleForm.gameEndTime =
            this.ruleForm.activityDate && this.ruleForm.activityDate.length > 0
              ? this.ruleForm.activityDate[1]
              : "";
          if (this.ruleForm.enabledState && this.ruleForm.updateMode) {
            this.ruleForm.enabledState = "";
            this.ruleForm.updateMode = "";
          }
          this.ruleForm.estimatedNum = new Number(this.ruleForm.estimatedNum);
          let params = this.ruleForm;

          params.gameType = "turntable";
          params.gameBgp = this.listHeaderImgUrl;
          params.gameBgp2 = this.gameBgp2;
          params.gameBgp3 = this.gameBgp3;
          if (this.rule.drawType == "daily") {
            this.rule.drawPrizeNum = this.rule.drawPrizeNumDaily;
            this.rule.eachWinningUpperLimit = this.rule.eachWinningUpperLimitDaily;
          } else {
            this.rule.drawPrizeNum = this.rule.drawPrizeNumTotal;
            this.rule.eachWinningUpperLimit = this.rule.eachWinningUpperLimitTotal;
          }
          if (!this.rule.uiType) {
            this.rule.uiType = this.$route.query.wheelType || "wheel";
          }
          this.rule.estimatedNum = this.ruleForm.estimatedNum;
          params = Object.assign(params, {
            rule: this.rule,
            threshold: this.threshold
          });
          this.$store.dispatch("addTurntable", params).then(res => {
            if (res.code === "0") {
              this.$message({
                message: "操作成功",
                type: "success"
              });
              this.$router.back(-1);
            }
          });
        } else {
          return false;
        }
      });
    },
    handleRemove(index) {
      this.$set(this.rule.turntablePrizeRuleList[index], "prizeImg", "");
    },
    handleRemoveGameBgp2() {
      this.gameBgp2 = "";
    },
    handleRemoveBgp3() {
      this.gameBgp3 = "";
    },
    bgm() {
      let audio = document.querySelector("#audio");

      if (!this.isPlaying) {
        audio.play();
        this.isPlaying = true;
      } else {
        audio.pause();
        this.isPlaying = false;
      }
    },
    minimum() {
      this.isCollapse = !this.isCollapse;
    },
    getImageSize(){
      if(this.wheelType==="wheel"){
        //圆形转盘
        this.gameBgp2Name = "上传转盘图";
        this.gameBgp2UploadWidth = 640;
        this.gameBgp2UploadHeight = 640;
        this.gameBgp3Name = "上传转盘指针图";
        this.gameBgp3UploadWidth = 142;
        this.gameBgp3UploadHeight = 180;
      }else if(this.wheelType==="grid"){
        //九宫格转盘
        this.gameBgp2Name = "上传九宫格框";
        this.gameBgp2UploadWidth = 750;
        this.gameBgp2UploadHeight = 1226;
        this.gameBgp3Name = "上传立即抽奖按钮";
        this.gameBgp3UploadWidth = 200;
        this.gameBgp3UploadHeight = 200;
      }else if(this.wheelType==="roll"){
        //滚动转盘
        this.gameBgp2Name = "上传滚动框";
        this.gameBgp2UploadWidth = 750;
        this.gameBgp2UploadHeight = 1224;
        this.gameBgp3Name = "上传滚动指针图";
        this.gameBgp3UploadWidth = 53;
        this.gameBgp3UploadHeight = 300;
      }
    },
  }
};
</script>
<style lang="scss">
.game-select {
  .el-select {
    width: 140px !important;
    .el-input {
      width: 140px !important;
    }
  }
}
</style>
<style lang="scss" scoped>
.gb-wheel-container ul,
.gb-wheel-container li,
.gb-wheel-container p {
  margin: 0;
  padding: 0;
}
.gb-wheel-img {
  img {
    margin-top: 5px;
    width: 25px;
    height: 25px;
  }
}
.upload-upload-btn {
  .tips {
    color: #999;
    font-size: 12px;
    line-height: 20px;
  }

  .btn {
    border: 1px solid #ddd;
    text-align: center;
    padding: 10px;
    margin-right: 10px;
    width: 130px;
    height: 130px;
    cursor: pointer;
    .add-wrapper {
      width: 30px;
      height: 30px;
      line-height: 30px;
      background: #e50065;
      color: #fff;
      text-align: center;
      border-radius: 50%;
      margin: 0 auto;
      span {
        font-size: 12px;
      }
      cursor: pointer;
      .hmicon {
        font-size: 14px;
      }
    }
  }
}
// @keyframes rotate {
//   from {
//     transform: rotate(0);
//   }
//   to {
//     transform: rotate(1turn);
//   }
// }

.gb-wheel-container ul,
.gb-wheel-container li {
  list-style: none;
}

.gb-wheel-container {
  margin: 0 auto;
  position: relative;
  width: 320px;
  height: 320px;
  border-radius: 50%;
  overflow: hidden;
}

.gb-wheel-content {
  position: absolute;
  left: 21px;
  top: 21px;
  z-index: 2;
  width: 280px;
  height: 280px;
  box-sizing: border-box;
  border-radius: inherit;
  background-size: 12px 14px;
}

.gb-wheel-list {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
}

.gb-wheel-item {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  color: #fff;
  font-weight: bold;
  text-shadow: 0 1px 1px rgba(255, 255, 255, 0.6);
}

.gb-wheel-itext {
  font-size: 1.4rem;
  font-weight: lighter;
  .add,
  .delete {
    background: rgba(0, 0, 0, 0.5);
    display: inline-block;
    width: 24px;
    height: 24px;
    color: #fff;
    cursor: pointer;
    font-size: 14px;
    line-height: 20px;
    text-align: center;
    margin-right: 10px;
    border-radius: 5px;
    display: none;
  }
}

.gb-wheel-money [class*="icono-"] {
  color: #fff;
}

.gb-wheel-line {
  position: absolute;
  left: 0;
  top: 0;
  width: inherit;
  height: inherit;
  z-index: 99;
}

.gb-wheel-litem {
  position: absolute;
  left: 140px;
  top: 0;
  width: 1px;
  height: 140px;
  background-color: #fff;
  overflow: hidden;
  transform-origin: 50% 140px;
  opacity: 0.2;
}

.gb-wheel-icontent {
  position: relative;
  display: block;
  padding-top: 20px;
  margin: 0 auto;
  text-align: center;
  transform-origin: 50% 130px;
  z-index: 1;
  p {
    color: #fff;
    font-size: 10px;
  }
  &:hover {
    .gb-wheel-itext {
      .add,
      .delete {
        display: inline-block;
      }
    }
  }
}
.gb-wheel-btn {
  z-index: 400;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  height: 90px;
  line-height: 104px;
  width: 71px;
  color: #fff;
  text-align: center;
  //background: url("https://imgcdn.hemiao100.com/hemiaoBase/turnTable/%E8%BD%AC%E7%9B%98-06.png");
  background-size: 100%;
  background-repeat: no-repeat;
  border: none;
  font-size: 20px;
}

a.gb-wheel-btn {
  border-bottom: none;
}

.gb-wheel-btn.disabled,
.gb-wheel-btn.disabled::after {
  pointer-events: none;
  background: #b07a7b;
  color: #ccc;
}
.turnTable {
  position: relative;
  height: 420px;
  .circle {
    position: absolute;
    top: 165px;
    height: 320px;
    width: 320px;
    z-index: 20;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    left: 50%;
    transform: translateX(-50%);
    border-radius: 50%;
    box-shadow: 0px 0px 8px 6px rgba(0, 0, 0, 0.1);
    &:hover {
      .add-prize,
      .upload-img {
        display: block;
      }
    }
    .add-prize,
    .upload-img {
      position: absolute;
      cursor: pointer;
      display: none;
      top: 0;
      z-index: 9030;
      zoom: 1;
      width: 34px;
      height: 34px;
      font-size: 12px;
      background-color: rgba(0, 0, 0, 0.8);
      border: 1px solid #fff;
      border-radius: 4px;
      text-align: center;
      line-height: 34px;
      .hmicon {
        color: #fff;
      }
    }
    .add-prize {
      left: 36px;
    }
    .upload-img {
      left: 0;
    }
  }
  .pedestal {
    position: absolute;
    bottom: 0;
    width: 320px;
    height: 160px;
    margin: 0 auto;
    background: url("https://imgcdn.hemiao100.com/hemiaoBase/5e03a2c5-657b-4307-b5dc-b1628ecca7c2.png");
    background-size: 100% 100%;
    left: 50%;
    transform: translateX(-50%);
  }

  .btn {
    font-size: 10px;
    background: #fddb00;
    color: #ff363e;
    box-shadow: 0px 0px 8px 1px rgba(239, 33, 6, 0.1) inset;
    border: 1px solid transparent;
    border-radius: 30px;
    padding: 7.5px 10px;
  }
  .prize {
    margin-left: 3rem;
  }
  .rule {
    margin-right: 3rem;
  }
}
.fixed-but {
  position: fixed;
  top: 150px;
  right: 20px;
}
// .rotate {
//   -webkit-animation: rotating 1.2s linear infinite;
//   -moz-animation: rotating 1.2s linear infinite;
//   -o-animation: rotating 1.2s linear infinite;
//   animation: rotating 1.2s linear infinite;
// }
.table {
  border: 1px solid #ddd;
  .table-header {
    padding: 16px 0;
    background: #f7f7f7;
    font-size: 14px;
    font-weight: bold;
  }
  .table-row {
    padding: 5px 0;
    font-size: 14px;
  }
  .table-row:nth-child(even) {
    background: #f7f7f7;
  }
  .add-wrapper,
  .minus-wrapper {
    margin: 0 auto;
  }
}
.priview {
  position: relative;
  width: 400px;
  height: 667px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  img {
    width: 100%;
    height: 100%;
  }
  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}
.priviewbgp2 {
  position: relative;
  width: 400px;
  height: 400px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  img {
    width: 100%;
    height: 100%;
  }
  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}
.priviewbgp3 {
  position: relative;
  width: 150px;
  height: 161px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  img {
    width: 100%;
    height: 100%;
  }
  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}

.goods-upload-btn {
  .tips {
    color: #999;
    font-size: 12px;
    line-height: 20px;
  }

  .logo {
    width: 80px;
    height: 80px;
  }

  .btn {
    border: 1px solid #ddd;
    text-align: center;
    padding: 10px;
    width: 80px;
    height: 80px;
    cursor: pointer;
    .add-wrapper {
      width: 30px;
      height: 30px;
      line-height: 30px;
      background: #e50065;
      color: #fff;
      text-align: center;
      border-radius: 50%;
      margin: 0 auto;
      span {
        font-size: 12px;
      }
      cursor: pointer;
      .hmicon {
        font-size: 14px;
        margin-right: 0 !important;
      }
    }
  }
}
.add-prize-img-wrapper {
  width: 20px;
  height: 20px;
  line-height: 20px;
  background: #e50065;
  color: #fff;
  text-align: center;
  border-radius: 50%;
  user-select: none;
  .hmicon {
    font-size: 14px;
    margin-right: 0px;
  }
}

.act-container {
  max-width: 2000px;
  overflow-x: auto;
  transform: scale(1);
  .step-wrapper {
    border-bottom: none !important;
    margin-bottom: 0;
  }
  .add-goods-container {
    width: calc(100% - 400px);
    flex-shrink: 0;
  }
  .slot {
    background-size: 100% 100%;
    height: 100%;
    position: relative;
    &:hover {
      .change-bg {
        display: block;
      }
    }
    .change-bg {
      position: absolute;
      top: 60px;
      right: 0;
      height: 34px;
      font-size: 12px;
      background-color: rgba(0, 0, 0, 0.8);
      border: 1px solid #fff;
      border-radius: 4px;
      text-align: center;
      line-height: 34px;
      color: #fff;
      z-index: 10;
      padding: 0 10px;
      display: none;
    }
    &.wheel {
      .music {
        position: fixed;
        top: 120px;
        left: 20px;
        .hmicon {
          font-size: 28px;
          display: block;
          color: #ffc9b4;
        }
      }
      .times-wrapper {
        position: absolute;
        bottom: 80px;
        left: 0;
        right: 0;
      }
      .changce {
        margin: 0 auto;
        padding: 3px;
        border-radius: 30px;
        display: inline-block;

        .changce-wrapper {
          color: #fff;
          border-radius: 30px;
          padding: 10px 15px;
          word-break: keep-all;
        }
      }

      .times {
        background: #893eff;
        color: #fff;
        border-radius: 5px;
        font-weight: bold;
        padding: 0 5px;
        margin: 0 5px;
      }
    }
    &.grid {
      .grid-wheel-container {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 349px;
        height: 626px;
        background-size: 100% 100%;
      }
      .times-wrapper {
        position: absolute;
        top: 182px;
        left: 50%;
        transform: translateX(-50%);
        background: url("https://imgcdn.hemiao100.com/decoration/pseb18f15a3584cf1a-319d-4a55-9cbf-e6b91f5acb33.png");
        width: 212px;
        height: 30px;
        line-height: 30px;
        background-size: 100% 100%;
        text-align: center;
        color: #fff;
        font-size: 17px;
        font-weight: bold;

        .times {
          color: #f8e419;
        }
      }

      .btn.prize {
        background: url("https://imgcdn.hemiao100.com/decoration/pscfd0eb0108fd0004-9f1e-4c1a-b782-2c809f319448.png");
        background-size: 100% 100%;
        width: 78px;
        height: 43px;
        line-height: 43px;
        padding: 0;
        text-align: center;
        color: #fc4100;
        font-size: 14px;
        position: absolute;
        bottom: 4px;
        right: 4px;
      }

      /**index.wxss**/

      .frame_view {
        position: absolute;
        top: 241px;
        left: 24px;
        width: 304px;
        height: 306px;
        z-index: 3;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        border-radius: 15px;
        border-radius: 10px;
      }

      .frame_row {
        width: 290px;
        height: 90px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
      }

      .frame_item {
        position: absolute;
        width: 96px;
        height: 96px;
        z-index: 9;
        background: url("https://imgcdn.hemiao100.com/mall/psa34602b449499a4d-b22b-4c4e-b42f-c39c83a67d2b.png");
        background-size: 100% 100%;
        .grid-draw {
          width: 100%;
        }
        &:hover {
          .delete-item {
            display: block;
          }
        }
        &.active {
          background: url("https://imgcdn.hemiao100.com/mall/ps2f1bae0554f1ca1b-2daf-46ac-ba02-fe0ec02ebae8.png");
          background-size: 100% 100%;
        }

        &.lottery {
          top: 104px;
          left: 104px;
        }

        &.prize0 {
          top: 4px;
          left: 4px;
        }

        &.prize1 {
          top: 4px;
          left: 104px;
        }

        &.prize2 {
          top: 4px;
          left: 208px;
        }

        &.prize3 {
          left: 204px;
          top: 104px;
        }

        &.prize4 {
          left: 204px;
          top: 204px;
        }

        &.prize5 {
          left: 104px;
          top: 204px;
        }

        &.prize6 {
          left: 4px;
          top: 204px;
        }

        &.prize7 {
          left: 4px;
          top: 104px;
        }

        .img {
          width: 58px;
          height: 58px;
          margin: 6px auto;
          border-radius: 5px;
          display: block;
        }
        .title {
          text-align: center;
          font-size: 14px;
        }
      }

      .no-prize {
        .prize-name {
          height: 100%;
          font-size: 20px;
        }
      }
    }
    &.roll {
      .roll-wheel-container {
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 375px;
        height: 612px;
        background-size: 100% 100%;

        .swiper-wrapper {
          position: absolute;
          bottom: 40px;
          left: 16px;
          background: url("https://imgcdn.hemiao100.com/decoration/ps923d355475764855-7f71-4b89-bb7c-b5a7ad4bbcb3.png");
          background-size: 100% 100%;
          width: 259px;
          height: 43px;
          color: #fff;

          .avatar-wrapper {
            width: 29px;
            height: 29px;
            margin-right: 10px;
            border-radius: 50%;
            margin-left: 12px;

            image {
              height: 100%;
              border-radius: 50%;
              width: 100%;
            }
          }
        }

        .btn.prize {
          background: url("https://imgcdn.hemiao100.com/decoration/ps5a5697dff5e79296-9665-4281-a7d8-fb38ba05ee83.png");
          background-size: 100% 100%;
          width: 78px;
          height: 43px;
          line-height: 43px;
          padding: 0;
          text-align: center;
          color: #fff;
          font-size: 14px;
          position: absolute;
          bottom: 40px;
          right: 16px;
        }

        .times-wrapper {
          position: absolute;
          top: 142px;
          left: 50%;
          transform: translateX(-50%);
          color: #fff;
          font-size: 16px;
          font-weight: bold;
          .times {
            color: #f8e419;
          }
        }

        .roll-lottery {
          position: absolute;
          top: 405px;
          left: 50%;
          transform: translateX(-50%);
          width: 252px;
          height: 85px;
          background: url("https://imgcdn.hemiao100.com/decoration/ps50cc62643789e687-06a2-469d-baf7-0de6c18e1bc5.png");
          background-size: 100% 100%;
        }

        .pointer {
          position: absolute;
          top: 202px;
          left: 50%;
          transform: translateX(-50%);
          width: 26px;
          height: 150px;
          background-size: 100% 100%;
        }

        .roll-prize-wrapper {
          position: absolute;
          top: 208px;
          left: 44px;
          width: 286px;
          border-radius: 10px;
          height: 133px;
          overflow-x: auto;
          z-index: -1;
          .roll-item {
            width: 96px;
            height: 113px;
            border-radius: 10px;
            background: #fff;
            flex-shrink: 0;
            margin-right: 10px;
            &:hover {
              .delete-item {
                display: block;
                color: #fff;
              }
            }
          }
          .prize-name {
            font-size: 10px;
          }
          .img-wrapper {
            .img {
              height: 58px;
              width: 58px;
              border-radius: 5px;
              margin-bottom: 6px;
            }
          }
          .roll-list {
            &.roll {
              animation: slowRoll 10s linear infinite normal;
            }
            &.quick {
              animation: slowRoll 1s linear infinite normal;
            }
          }
        }

        @keyframes slowRoll {
          0% {
            transform: translate3d(0, 0, 0);
          }

          100% {
            transform: translate3d(-50%, 0, 0);
          }
        }
      }
    }
    .header-img-wrapper {
      box-sizing: border-box;
      .header-img {
        width: 100%;
        display: block;
      }
    }
    .empty {
      margin-top: 30px;
      text-align: center;
    }
  }
}
.priviews {
  position: relative;
  width: 80px;
  height: 80px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  margin: 10px;
  .img {
    width: 100%;
    height: 100%;
  }
  img {
    width: 100%;
    height: 100%;
  }
  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    // bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}
</style>
